/* DS product card tidy, 18 Oct 2026: zoom card photos past the white border baked into the image file. */
(function () {
  var PAD = 0.04, MAXK = 2.2, cache = {};
  function bbox(img) {
    var key = img.currentSrc || img.src;
    if (cache[key]) return cache[key];
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var s = Math.min(1, 160 / Math.max(nw, nh)), w = Math.max(1, Math.round(nw * s)), h = Math.max(1, Math.round(nh * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }), d;
    try { x.drawImage(img, 0, 0, w, h); d = x.getImageData(0, 0, w, h).data; } catch (e) { return (cache[key] = false); }
    var rows = new Array(h).fill(0), cols = new Array(w).fill(0);
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      var i = (yy * w + xx) * 4;
      if (d[i + 3] > 24 && (d[i] < 238 || d[i + 1] < 238 || d[i + 2] < 238)) { rows[yy]++; cols[xx]++; }
    }
    var tr = Math.max(1, w * 0.01), tc = Math.max(1, h * 0.01), t = 0, b = h - 1, l = 0, r = w - 1;
    while (t < h && rows[t] < tr) t++;
    while (b > t && rows[b] < tr) b--;
    while (l < w && cols[l] < tc) l++;
    while (r > l && cols[r] < tc) r--;
    if (t >= b || l >= r) return (cache[key] = false);
    return (cache[key] = { x: l / w, y: t / h, w: (r - l + 1) / w, h: (b - t + 1) / h, ar: nw / nh });
  }
  function apply(img) {
    if (!img.complete || !img.naturalWidth) return;
    var bb = bbox(img), box = img.parentElement;
    if (!bb || !box) return;
    var W = box.clientWidth, H = box.clientHeight;
    if (!W || !H) return;
    // size of the whole image when contained in the box
    var dw = Math.min(W, H * bb.ar), dh = dw / bb.ar;
    var cw = bb.w * dw, ch = bb.h * dh;
    var k = Math.min(W * (1 - 2 * PAD) / cw, H * (1 - 2 * PAD) / ch, MAXK);
    if (k <= 1.02) { img.classList.remove('ds-trim'); return; }
    var ox = (bb.x + bb.w / 2 - 0.5) * dw, oy = (bb.y + bb.h / 2 - 0.5) * dh;
    img.style.setProperty('--ds-k', k.toFixed(3));
    img.style.setProperty('--ds-x', (-ox / W * 100).toFixed(2) + '%');
    img.style.setProperty('--ds-y', (-oy / H * 100).toFixed(2) + '%');
    img.classList.add('ds-trim');
    // ask for a sharper file to match the zoom
    var need = Math.ceil(W * k);
    if (img.srcset && img.getAttribute('data-ds-sized') !== String(need)) { img.setAttribute('data-ds-sized', need); img.sizes = need + 'px'; }
  }
  function hook(img) {
    if (img.__dsHooked) { apply(img); return; }
    img.__dsHooked = true;
    img.addEventListener('load', function () { apply(img); });
    if (img.complete) apply(img);
  }
  function scan(root) {
    (root || document).querySelectorAll('.product-card-wrapper .card__media .media img').forEach(hook);
  }
  // deal box: copy the card's deal pill text into a box above the button; keep rows level with hidden spacers
  function deals() {
    var ws = document.querySelectorAll('.product-card-wrapper');
    ws.forEach(function (w) {
      var info = w.querySelector('.card__content > .card__information'); if (!info) return;
      var h = w.querySelector('.card__heading a'); if (h && !h.title) h.title = h.textContent.trim();
      var box = info.querySelector(':scope > .ds-deal-box');
      if (!box) {
        var pill = w.querySelector('.card-case-badge .deal-pill:not(.deal-pill--generic)');
        var txt = pill ? pill.textContent.trim() : '';
        // 20 Oct 2026: the generic "Multi-buy" tag sits in the same line as the deal box instead of over the photo
        var gen = !txt && w.querySelector('.card-case-badge .deal-pill--generic');
        box = document.createElement('div');
        box.className = 'ds-deal-box' + (txt ? '' : gen ? ' ds-deal-box--generic' : ' ds-deal-box--empty');
        if (txt) { box.textContent = txt; box.title = txt; w.classList.add('ds-has-deal'); }
        else if (gen) { box.textContent = gen.textContent.trim(); box.title = 'Multi-buy: more pack sizes available'; w.classList.add('ds-has-generic'); }
        else box.setAttribute('aria-hidden', 'true');
        info.appendChild(box);
      }
    });
    // spacer only where another card in the same visual row has a real box
    var rows = {};
    ws.forEach(function (w) {
      var b = w.querySelector('.ds-deal-box'); if (!b || !w.offsetParent) return;
      var r = w.parentElement ? w.parentElement.getBoundingClientRect() : w.getBoundingClientRect();
      var ul = w.closest('ul'), cr = ul ? ul.getBoundingClientRect() : null;
      // in sliders only the cards in view count, so an off-screen deal does not add a gap to the visible row
      if (cr && (r.right <= cr.left + 2 || r.left >= cr.right - 2)) { if (b.classList.contains('ds-deal-box--empty')) b.classList.add('ds-deal-box--none'); return; }
      var key = String(Math.round(r.top + window.scrollY));
      (rows[key] = rows[key] || []).push(b);
    });
    Object.keys(rows).forEach(function (k) {
      var any = rows[k].some(function (b) { return !b.classList.contains('ds-deal-box--empty'); });
      rows[k].forEach(function (b) { if (b.classList.contains('ds-deal-box--empty')) b.classList.toggle('ds-deal-box--none', !any); });
    });
  }
  function start() {
    scan(); deals();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length && !(ms[i].addedNodes[0].classList && ms[i].addedNodes[0].classList.contains('ds-deal-box'))) { scan(); deals(); break; }
    }).observe(document.body, { childList: true, subtree: true });
    var ts; document.addEventListener('scroll', function (e) { if (e.target && e.target.classList && e.target.classList.contains('slider')) { clearTimeout(ts); ts = setTimeout(deals, 120); } }, true);
    var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(function () { scan(); deals(); }, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
